import React from 'react';
import PropTypes from 'prop-types';
import outgoingClassesModule from './Outgoing.module.scss';
import messageBubbleClassesModule from '../MessageBubble.module.scss';
import { getUiConfig } from '../../../../utils/config';

function Outgoing(props) {
  const outgoingClasses = [outgoingClassesModule.Outgoing, messageBubbleClassesModule.MessageBubble];
  const configOutgoing = getUiConfig().outgoing_messages ?? {};
  const bubbleStyles = {
    color: configOutgoing.text_color ?? undefined,
    backgroundColor: configOutgoing.bubble_color ?? undefined,
    fontSize: configOutgoing.font_size ?? undefined,
    fontFamily: configOutgoing.font_family ?? undefined,
    boxShadow: configOutgoing.shadow ?? undefined,
    lineHeight: configOutgoing.line_height ?? undefined,
    padding: configOutgoing.padding ?? undefined,
  }

  if (props.isTop) {
    outgoingClasses.push(outgoingClassesModule.top);
  }
  if (props.isBottom) {
    outgoingClasses.push(outgoingClassesModule.bottom);
  }

  return <div className={outgoingClassesModule.OutgoingContainer}>
    <div className={outgoingClasses.join(' ')} style={bubbleStyles}>
      {props.message.text}
    </div>
    <div className={messageBubbleClassesModule.outgoingTimeStamp}>
      {props.timeStamp}
    </div>
  </div>;
}

Outgoing.propTypes = {
  message: PropTypes.object,
  isTop: PropTypes.bool,
  isBottom: PropTypes.bool,
  timeStamp: PropTypes.string
};

export default Outgoing;
